const BACKEND_ASSET_PREFIX = /^\/(storage|upload|uploads)\//;

export function apiAssetUrl(src?: string | null): string {
    if (!src) {
        return '';
    }

    if (/^https?:\/\//i.test(src) || !BACKEND_ASSET_PREFIX.test(src)) {
        return src;
    }

    return `${process.env.NEXT_PUBLIC_API_HOST || ''}${src}`;
}

export function localAssetUrl(src?: string | null): string {
    if (!src) {
        return '';
    }

    if (BACKEND_ASSET_PREFIX.test(src)) {
        return src;
    }

    if (/^https?:\/\//i.test(src)) {
        try {
            const { pathname } = new URL(src);

            if (BACKEND_ASSET_PREFIX.test(pathname)) {
                return pathname;
            }
        } catch {
            return src;
        }
    }

    return src;
}
